"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ejectPlayerAction = exports.EJECT_PLAYER = void 0;
exports.EJECT_PLAYER = 'EJECT_PLAYER';
function ejectPlayerAction(playerId) {
    return { type: exports.EJECT_PLAYER, playerId: playerId };
}
exports.ejectPlayerAction = ejectPlayerAction;
